module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-accordion__box"
  }, [_c('div', {
    staticClass: "m-accordion__header",
    class: {
      'm-accordion__box--closed': !_vm.isOpen,
      'm-accordion__box--closed--has-error': _vm.hasError && !_vm.isOpen,
        'm-accordion__box--open': _vm.isOpen && _vm.showOpen
    },
    on: {
      "click": function($event) {
        return _vm.triggerOpenNext(_vm.index)
      }
    }
  }, [_vm._t("header"), _vm._v(" "), _c('span', {
    class: ['accordion-header-icon', {
      'accordion-header-icon-open': _vm.isOpen,
      'accordion-header-icon-closed': !_vm.isOpen
    }]
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isOpen),
      expression: "isOpen"
    }],
    staticClass: "m-accordion__item-content",
    class: {
      'm-accordion__item-content--pull': _vm.contentPull
    }
  }, [_vm._t("default"), _vm._v(" "), (_vm.isOpen) ? _vm._t("if-slot") : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6b1461a2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accordion/AccordionItem.vue
// module id = 1730
// module chunks = 0